import React from 'react'
import PropTypes from 'prop-types'

import MainFirst from './../block/MainFirst'
import ShortInfo from './../block/ShortInfo'
import Cards1 from './../block/Cards1'
import WindowsBlock from './../block/WindowsBlock'
import HideContentBlock from './../block/HideContentBlock'
import TakzeMiniBlock from './../block/TakzeMiniBlock'
import PhotoGallarySlyder from './../block/PhotoGallarySlyder'
import Ruchkibezopasnost from './../block/Ruchkibezopasnost'
import NetPhotoMiniBlock from './../block/NetPhotoMiniBlock'
import ProdukciyaDirs from './../block/ProdukciyaDirs'
import Showroom from './../block/Showroom'

class OknaIzDuba extends React.Component {

  render() {

    const { data, protocol, assets_path } = this.props

    return (
      <>
        <MainFirst
          data={data?.main_first || {}}
          protocol={protocol}
          assets_path={assets_path}
        />
        <Cards1
          list={data?.oknacards || []}
          layout={7}
          cols={`2-all`}
          margin={`top`}
        />
        <ShortInfo
          data={data?.short_info || {}}
          assets_path={assets_path}
        />
        <WindowsBlock
          data={data?.windows_block || {}}
          margin={`bottom`}
        />
        {data.id == 25 ?
          <>
            <TakzeMiniBlock />
            <PhotoGallarySlyder
              data={data?.photogallary || {}}
              margin={`bottom`}
            />
          </>
        :
          <>
            <PhotoGallarySlyder
              data={data?.photogallary || {}}
              margin={`bottom`}
            />
          </>
        }
        <Ruchkibezopasnost
          title={data?.preim_title}
          rtext={`[Удобство в каждой детали]`}
          list={data?.zamki?.list || []}
          image={data?.zamki?.image}
          icon={true}
          btn={false}
          className={`none`}
        />
        <HideContentBlock
          data={data?.hidecontent || {}}
        />
        <PhotoGallarySlyder
          data={data?.photogallary2 || {}}
          margin={`top-bottom-10`}
        />
        <NetPhotoMiniBlock />
        <ProdukciyaDirs
          produkciya_page={data?.produkciya_page}
        />
        <Cards1
          title={`Работаем на качество и <span>несем <br />ответственность за свою работу</span>`}
          rtext={``}
          text={``}
          list={data?.nakachestvo || []}
          cols={1}
          margin={`top`}
          bg={1}
          layout={8}
        />
        <Showroom
          data={data?.showroom || {}}
          dark_bg={data?.dark_bg || ''}
          dark_bg_mob={data?.dark_bg_mob || ''}
          assets_path={assets_path}
          margin={`y`}
        />
      </>
    )
  }
}

OknaIzDuba.propTypes = {
  data: PropTypes.object,
  protocol: PropTypes.string,
  assets_path: PropTypes.string
}

OknaIzDuba.defaultProps = {
  data: {},
  protocol: 'https',
  assets_path: 'assets'
}

export default OknaIzDuba